import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import HowWeTransform from "./pages/HowWeTransform";
import AiOpportunities from "./pages/AiOpportunities";
import CognitiveAI from "./pages/CognitiveAI";
import About from "./pages/About";
import Insights from "./pages/Insights";
import SimpelLabs from "./pages/SimpelLabs";
import { AuraProvider } from "./components/aura/AuraProvider";
import AuraLauncher from "./components/aura/AuraLauncher";

import Discover from "./pages/Discover";
import SimpelLoop from "./pages/SimpelLoop";
import CaseStudies from "./pages/CaseStudies";
import SkipperCaseStudy from "./pages/SkipperCaseStudy";
// import ErpServices from "./pages/ErpServices";
// import IntegrationServices from "./pages/IntegrationServices";
// import WhatsappBotServices from "./pages/WhatsappBotServices";
import Career from "./pages/Career";
import AiEngineerRole from "./pages/AiEngineerRole";
import OpenPositions from "./pages/OpenPositions";
import FinancialServicesCaseStudy from "./pages/FinancialServicesCaseStudy";
import WhatWeDo from "./pages/WhatWeDo";
import ManufacturingStackPage from "./pages/ManufacturingStackPage";
import SalesStackPage from "./pages/SalesStackPage";
import AgenticAiPage from "./pages/AgenticAiPage";
import LegacyDataMigrationPage from "./pages/LegacyDataMigrationPage";
import AutomationAuditPage from "./pages/AutomationAuditPage";
import AutomatedWorkflowsPage from "./pages/AutomatedWorkflowsPage";
import DigitalWorkersPage from "./pages/DigitalWorkersPage";
import ErpImplementationsPage from "./pages/ErpImplementationsPage";
import EkRewardsPage from "./pages/EkRewardsPage";
import XpSkillsPage from "./pages/XpSkillsPage";
import SimpelErpPage from "./pages/SimpelErpPage";
import AutomobileCaseStudy from "./pages/AutomobileCaseStudy";
import ProfessionalServicesCaseStudy from "./pages/ProfessionalServicesCaseStudy";
import FinancialResearchAssistant from "./pages/FinancialResearchAssistant";
import KnowledgeCopilot from "./pages/KnowledgeCopilot";
import PredictiveMaintenance from "./pages/PredictiveMaintenance";
import ProductionCopilot from "./pages/ProductionCopilot";
import ClinicalKnowledgeAssistant from "./pages/ClinicalKnowledgeAssistant";
import HealthcareOperationsCopilot from "./pages/HealthcareOperationsCopilot";
import PatientExperienceCopilot from "./pages/PatientExperienceCopilot";
import AIResearchAssistant from "./pages/AIResearchAssistant";
import ProposalRfpIntelligence from "./pages/ProposalRfpIntelligence";
import QualityIntelligence from "./pages/QualityIntelligence";
import RelationshipManagerCopilot from "./pages/RelationshipManagerCopilot";
import CitizenServicesAssistant from "./pages/CitizenServicesAssistant";
import OurStoryModal from "./components/OurStoryModal";
import LegalPage from "./pages/LegalPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuraProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/services/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/what-we-do/services/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/what-we-do/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/services/legacy-data-migration" element={<LegacyDataMigrationPage />} />
            <Route path="/what-we-do/services/legacy-data-migration" element={<LegacyDataMigrationPage />} />
            <Route path="/what-we-do/legacy-data-migration" element={<LegacyDataMigrationPage />} />
            <Route path="/legacy-data-migration" element={<LegacyDataMigrationPage />} />
            <Route path="/services/automation-audit" element={<AutomationAuditPage />} />
            <Route path="/what-we-do/services/automation-audit" element={<AutomationAuditPage />} />
            <Route path="/what-we-do/automation-audit" element={<AutomationAuditPage />} />
            <Route path="/automation-audit" element={<AutomationAuditPage />} />
            <Route path="/services/automated-workflows" element={<AutomatedWorkflowsPage />} />
            <Route path="/what-we-do/services/automated-workflows" element={<AutomatedWorkflowsPage />} />
            <Route path="/what-we-do/automated-workflows" element={<AutomatedWorkflowsPage />} />
            <Route path="/automated-workflows" element={<AutomatedWorkflowsPage />} />
            <Route path="/services/digital-workers" element={<DigitalWorkersPage />} />
            <Route path="/what-we-do/services/digital-workers" element={<DigitalWorkersPage />} />
            <Route path="/what-we-do/digital-workers" element={<DigitalWorkersPage />} />
            <Route path="/digital-workers" element={<DigitalWorkersPage />} />
            <Route path="/services/erp-implementations" element={<ErpImplementationsPage />} />
            <Route path="/what-we-do/services/erp-implementations" element={<ErpImplementationsPage />} />
            <Route path="/what-we-do/erp-implementations" element={<ErpImplementationsPage />} />
            <Route path="/erp-implementations" element={<ErpImplementationsPage />} />
            <Route path="/what-we-do/manufacturing-automation-stack" element={<ManufacturingStackPage />} />
            <Route path="/stack/manufacturing-automation" element={<ManufacturingStackPage />} />
            <Route path="/manufacturing-automation-stack" element={<ManufacturingStackPage />} />
            <Route path="/what-we-do/sales-automation-stack" element={<SalesStackPage />} />
            <Route path="/sales-automation-stack" element={<SalesStackPage />} />
            <Route path="/stack/sales-automation" element={<SalesStackPage />} />
            <Route path="/products/ek-rewards" element={<EkRewardsPage />} />
            <Route path="/what-we-do/products/ek-rewards" element={<EkRewardsPage />} />
            <Route path="/what-we-do/ek-rewards" element={<EkRewardsPage />} />
            <Route path="/ek-rewards" element={<EkRewardsPage />} />
            <Route path="/products/xp-skills" element={<XpSkillsPage />} />
            <Route path="/what-we-do/products/xp-skills" element={<XpSkillsPage />} />
            <Route path="/what-we-do/xp-skills" element={<XpSkillsPage />} />
            <Route path="/xp-skills" element={<XpSkillsPage />} />
            <Route path="/products/simpel-erp" element={<SimpelErpPage />} />
            <Route path="/what-we-do/products/simpel-erp" element={<SimpelErpPage />} />
            <Route path="/what-we-do/simpel-erp" element={<SimpelErpPage />} />
            <Route path="/simpel-erp" element={<SimpelErpPage />} />
            <Route path="/transform" element={<HowWeTransform />} />
            {/* <Route path="/services/erp" element={<ErpServices />} /> */}
            {/* <Route path="/services/integration" element={<IntegrationServices />} /> */}
            {/* <Route path="/services/whatsapp-bot" element={<WhatsappBotServices />} /> */}
            {/* <Route path="/whatsapp-bot" element={<WhatsappBotServices />} /> */}
            <Route path="/simpel-loop" element={<SimpelLoop />} />
            <Route path="/loop" element={<SimpelLoop />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/skipper-limited" element={<SkipperCaseStudy />} />
            <Route path="/case-studies/skipper" element={<SkipperCaseStudy />} />
            <Route path="/skipper-limited" element={<SkipperCaseStudy />} />
            <Route path="/ai-opportunities" element={<AiOpportunities />} />
            <Route path="/cognitive" element={<CognitiveAI />} />
            <Route path="/labs" element={<SimpelLabs />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/financial-services" element={<FinancialServicesCaseStudy />} />
            <Route path="/case-study/finance-services" element={<FinancialServicesCaseStudy />} />
            <Route path="/case-studies/financial-services" element={<FinancialServicesCaseStudy />} />
            <Route path="/insights/automobile-tier-2-supplier" element={<AutomobileCaseStudy />} />
            <Route path="/case-study/automobile-tier-2-supplier" element={<AutomobileCaseStudy />} />
            <Route path="/case-studies/automobile-tier-2-supplier" element={<AutomobileCaseStudy />} />
            <Route path="/insights/professional-services" element={<ProfessionalServicesCaseStudy />} />
            <Route path="/case-study/professional-services" element={<ProfessionalServicesCaseStudy />} />
            <Route path="/case-studies/professional-services" element={<ProfessionalServicesCaseStudy />} />
            <Route path="/financial-research-assistant" element={<FinancialResearchAssistant />} />
            <Route path="/industries/financial-services/financial-research-assistant" element={<FinancialResearchAssistant />} />
            <Route path="/cognitive/financial-research-assistant" element={<FinancialResearchAssistant />} />
            <Route path="/cognitive/industries/financial-services" element={<FinancialResearchAssistant />} />
            <Route path="/knowledge-copilot" element={<KnowledgeCopilot />} />
            <Route path="/cognitive/industries/professional-services/knowledge-copilot" element={<KnowledgeCopilot />} />
            <Route path="/cognitive/industries/knowledge-copilot" element={<KnowledgeCopilot />} />
            <Route path="/predictive-maintenance" element={<PredictiveMaintenance />} />
            <Route path="/cognitive/industries/manufacturing/predictive-maintenance" element={<PredictiveMaintenance />} />
            <Route path="/cognitive/predictive-maintenance" element={<PredictiveMaintenance />} />
            <Route path="/production-copilot" element={<ProductionCopilot />} />
            <Route path="/cognitive/industries/manufacturing/production-copilot" element={<ProductionCopilot />} />
            <Route path="/cognitive/production-copilot" element={<ProductionCopilot />} />
            <Route path="/clinical-knowledge-assistant" element={<ClinicalKnowledgeAssistant />} />
            <Route path="/cognitive/industries/healthcare/clinical-knowledge-assistant" element={<ClinicalKnowledgeAssistant />} />
            <Route path="/cognitive/clinical-knowledge-assistant" element={<ClinicalKnowledgeAssistant />} />
            <Route path="/healthcare-operations-copilot" element={<HealthcareOperationsCopilot />} />
            <Route path="/cognitive/industries/healthcare/healthcare-operations-copilot" element={<HealthcareOperationsCopilot />} />
            <Route path="/cognitive/healthcare-operations-copilot" element={<HealthcareOperationsCopilot />} />
            <Route path="/patient-experience-copilot" element={<PatientExperienceCopilot />} />
            <Route path="/cognitive/industries/healthcare/patient-experience-copilot" element={<PatientExperienceCopilot />} />
            <Route path="/cognitive/patient-experience-copilot" element={<PatientExperienceCopilot />} />
            <Route path="/ai-research-assistant" element={<AIResearchAssistant />} />
            <Route path="/cognitive/industries/professional-services/ai-research-assistant" element={<AIResearchAssistant />} />
            <Route path="/cognitive/ai-research-assistant" element={<AIResearchAssistant />} />
            <Route path="/proposal-rfp-intelligence" element={<ProposalRfpIntelligence />} />
            <Route path="/cognitive/industries/professional-services/proposal-rfp-intelligence" element={<ProposalRfpIntelligence />} />
            <Route path="/cognitive/proposal-rfp-intelligence" element={<ProposalRfpIntelligence />} />
            <Route path="/quality-intelligence" element={<QualityIntelligence />} />
            <Route path="/cognitive/industries/manufacturing/quality-intelligence" element={<QualityIntelligence />} />
            <Route path="/cognitive/quality-intelligence" element={<QualityIntelligence />} />
            <Route path="/relationship-manager-copilot" element={<RelationshipManagerCopilot />} />
            <Route path="/cognitive/industries/financial-services/relationship-manager-copilot" element={<RelationshipManagerCopilot />} />
            <Route path="/cognitive/relationship-manager-copilot" element={<RelationshipManagerCopilot />} />
            <Route path="/citizen-services-assistant" element={<CitizenServicesAssistant />} />
            <Route path="/cognitive/industries/government-public-services/citizen-services-assistant" element={<CitizenServicesAssistant />} />
            <Route path="/cognitive/industries/citizen-services-assistant" element={<CitizenServicesAssistant />} />
            <Route path="/cognitive/citizen-services-assistant" element={<CitizenServicesAssistant />} />
            <Route path="/cognitive/industries/healthcare" element={<ClinicalKnowledgeAssistant />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/career" element={<Career />} />
            <Route path="/careers/open-positions" element={<OpenPositions />} />
            <Route path="/careers/roles" element={<OpenPositions />} />
            <Route path="/open-positions" element={<OpenPositions />} />
            <Route path="/careers/:roleId" element={<AiEngineerRole />} />
            <Route path="/career/:roleId" element={<AiEngineerRole />} />
            <Route path="/careers/roles/:roleId" element={<AiEngineerRole />} />
            <Route path="/privacy-policy" element={<LegalPage initialTab="privacy-policy" />} />
            <Route path="/privacy" element={<LegalPage initialTab="privacy-policy" />} />
            <Route path="/terms-of-use" element={<LegalPage initialTab="terms-of-use" />} />
            <Route path="/terms" element={<LegalPage initialTab="terms-of-use" />} />
            <Route path="/cookie-policy" element={<LegalPage initialTab="cookie-policy" />} />
            <Route path="/cookies" element={<LegalPage initialTab="cookie-policy" />} />
            <Route path="/legal" element={<LegalPage initialTab="privacy-policy" />} />
            <Route path="/discover" element={<Discover />} />
          </Routes>
          <AuraLauncher />
          <OurStoryModal />
        </AuraProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
